/** *@name:mgVxeColumn *@author:dingyongya *@date:2022/11/14 14:03 *@update:2022/11/14 14:03 */

<template>
  <vxe-column
    v-bind="{ showOverflow: 'tooltip', ...column }"
    :title="column.label"
    :field="column.prop"
    resizable
    :filters="[{ data: '' }]"
    :filter-method="(config) => filterMethod(config, column.prop)"
    :header-class-name="
      !hiddenHeaderStar && column.required && !column.headerSlot && !column.headerSearch ? 'header-required' : ''
    "
  >
    <!-- 自定义表头 -->
    <template v-if="column.headerSlot || column.headerSearch || column.type === 'seq'" #header="scoped">
      <div
        v-if="column.label"
        :class="['mg-customer-table-header-cell-label', column.required ? 'mg-header-asterisk' : '']"
      >
        <span :class="!hiddenHeaderStar && column.required ? 'star_color' : ''">{{ column.label }}</span>
      </div>
      <div v-if="showSearchBar" class="mg-customer-table-header-cell-body">
        <slot name="headerInput" v-bind:scoped="scoped"></slot>
      </div>
      <slot name="headerSlot"></slot>
    </template>
    <!--	slot 表体列	-->
    <template v-if="column.slot" #default="scoped">
      <slot v-bind="{ ...scoped }"></slot>
    </template>
  </vxe-column>
</template>

<script>
  export default {
    name: 'mgVxeColumn',
    inject: ['hiddenHeaderStar'],
    props: {
      column: {
        type: Object,
        default: () => {},
      },
      showSearchBar: Boolean,
      headerSearch: Boolean,
      filterMethod: Function,
    },
  }
</script>

<style scoped lang="scss">
  @import '../../style/index.scss';
  .star_color::before {
    content: '*';
    color: #e60012;
    top: 3px;
    position: relative;
    padding-right: 2px;
  }
</style>
